<ng-container *transloco="let translate">
  <div fxFlex="100" fxLayout="column">
    <ng-content></ng-content>

    <rmb-quick-filters-header [active]="active" [limit]="limit" (resetClicked)="onReset()" (saveClicked)="addOrUpdateFilter($event)">
    </rmb-quick-filters-header>

    <div class="px-30 py-10">
      @if (invalidForm) {
        <eg-alert fxFlex="50" type="error" message="{{ translate(TRANSLOCO_PREFIX + '.atLeastOne') }}"> </eg-alert>
      }
    </div>
  </div>
</ng-container>
